'use client'

import { Button } from './button'

export interface PageErrorProps {
  title?: string
  description?: string
  retryLabel?: string
  onRetry: () => void
  /**
   * FO-364 - opaque fout-referentie (App Insights OperationId of de Next.js
   * error-digest), klein en grijs onder de retry-knop. Zonder referentie is
   * een gebruikersmelding ("er ging iets mis") niet herleidbaar in de logs.
   * De id bevat zelf geen foutdetail (geen stack, geen PII). Leeg/afwezig =>
   * de regel wordt niet gerenderd.
   */
  refId?: string | null
}

/**
 * Presentational foutkaart voor error-boundaries (error.tsx).
 * Het boundary zelf doet de Sentry-capture en geeft reset() door als onRetry.
 * Default-copy is NL; klant-app geeft i18n-teksten mee via de props.
 */
export function PageError({
  title = 'Er ging iets mis',
  description = 'Deze pagina kon niet worden geladen. Probeer het opnieuw.',
  retryLabel = 'Opnieuw proberen',
  onRetry,
  refId,
}: PageErrorProps) {
  return (
    <div className="flex min-h-[50vh] w-full items-center justify-center px-4 py-8">
      <div className="w-full max-w-md rounded-xl border border-streep-border bg-streep-surface p-6 text-center shadow-sm md:p-8">
        <h2 className="text-lg font-semibold text-streep-donker">{title}</h2>
        <p className="mt-2 text-sm leading-relaxed text-streep-text-muted">{description}</p>
        <Button
          onClick={onRetry}
          size="lg"
          className="mt-6 w-full bg-streep-groen font-semibold text-streep-donker hover:bg-streep-groen/90 sm:w-auto"
        >
          {retryLabel}
        </Button>
        {refId ? (
          <p className="mt-3 break-all text-xs text-streep-text-muted">ref: {refId}</p>
        ) : null}
      </div>
    </div>
  )
}
